try {
    window.Swal =   require('sweetalert2/dist/sweetalert2');
    window.toastr = require('toastr');
    
    require('bootstrap-select/js/bootstrap-select');
    require('bootstrap-datepicker');
    require('select2');
} catch (e) {}

// import sweetalert2;

// import sweetalert2 Theme
// import 'sweetalert2/src/sweetalert2.scss';
import '@sweetalert2/themes/dark/dark.scss';
// import '@sweetalert2/themes/borderless/borderless.scss';
// import '@sweetalert2/themes/wordpress-admin/wordpress-admin.scss';
// import '@sweetalert2/themes/bootstrap-4/bootstrap-4.scss';
// import '@sweetalert2/themes/bulma/bulma.scss';
// import '@sweetalert2/themes/material-ui/material-ui.scss';
// import '@sweetalert2/themes/minimal/minimal.scss';
